import {useEffect, useRef, useState} from "react";
import {Button} from "antd";
import {useTranslation} from "react-i18next";
import {registerTurnstileHost} from "./turnstile";

// mounted once in App: every protected request borrows this container, so no form renders its own
// widget. it stays out of sight unless Cloudflare asks the client to click, and then shows as a dialog.
// visibility rather than display, because the widget still has to run while nothing is shown
const TurnstileHost = () => {
    const {t} = useTranslation();
    const containerRef = useRef(null);
    const cancelRef = useRef(null);
    const [interactive, setInteractive] = useState(false);

    useEffect(
        () =>
            registerTurnstileHost({
                get container() {
                    return containerRef.current;
                },
                setInteractive: (value, onCancel) => {
                    cancelRef.current = value ? onCancel : null;
                    setInteractive(!!value);
                },
            }),
        [],
    );

    return (
        <div
            aria-hidden={!interactive}
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 2000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: interactive ? "rgba(0, 0, 0, 0.45)" : "transparent",
                visibility: interactive ? "visible" : "hidden",
                pointerEvents: interactive ? "auto" : "none",
            }}
        >
            <div
                role="dialog"
                style={{
                    background: "#fff",
                    borderRadius: 8,
                    padding: "20px 24px 12px",
                    textAlign: "center",
                    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
                }}
            >
                <div style={{fontWeight: 600, marginBottom: 12, color: "rgba(0, 0, 0, 0.88)"}}>
                    {t("turnstile.securityCheck", {defaultValue: "Security check"})}
                </div>
                <div ref={containerRef} />
                <Button type="link" onClick={() => cancelRef.current?.()}>
                    {t("common.cancel", {defaultValue: "Cancel"})}
                </Button>
            </div>
        </div>
    );
};

export default TurnstileHost;
